import axios from 'axios';
import { supabase } from './lib/supabase';

const API_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

if (!API_URL && process.env.NODE_ENV === 'production') {
  console.warn('REACT_APP_BACKEND_URL is not set in production. Requests will fallback to current origin.');
}

/**
 * Axios instance for Python backend calls.
 */
const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000, // 30 second timeout to prevent indefinite hanging/aborts
});

api.interceptors.request.use(async (config) => {
  try {
    // Attach the Supabase JWT so the backend can verify identity if needed
    const { data, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Supabase session fetch error in interceptor:', error);
    }

    const session = data?.session;
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    } else {
      console.warn('API Request without session/token:', config.url);
    }
  } catch (err) {
    console.error('Interceptor failed to fetch session:', err);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (axios.isCancel(err)) {
      console.warn('Request was explicitly cancelled:', err.message);
    } else if (err.code === 'ECONNABORTED') {
      console.error('Request timed out (30s):', err.config?.url);
    } else if (err.message === 'Network Error') {
      console.error('Network Error - possible CORS or SSL issue:', err.config?.url);
    }

    const isHealthCheck = err.config?.url?.includes('/api/system/health');
    
    if (
      err.response?.status === 401 &&
      !window.location.pathname.includes('/login') &&
      !window.location.pathname.includes('/signup') &&
      !isHealthCheck
    ) {
      console.warn('Unauthorized (401) - clearing session and redirecting to login. URL:', err.config?.url);
      supabase.auth.signOut();
      localStorage.removeItem('admin_profile');
      window.location.href = '/login';
    } else if (err.response?.status === 401 && isHealthCheck) {
      console.warn('Health check failed with 401, but skipping logout to prevent session interruption.');
    }
    return Promise.reject(err);
  }
);

export default api;
